import {Box, HeaderFlex} from '@indoqa/style-system'
import * as React from 'react'
import {Link} from 'react-router-dom'
import {paths} from './App'
import {ReactComponent as Logo} from './digital-logo-small.svg'
import {LogoutButton} from './LogoutButton'

export const Header: React.FC = () => {
  return (
    <HeaderFlex
      fullWidth
      bg="bgContentEmphasised"
      px={4}
      height={45}
      alignItems="center"
      justifyContent="space-between"
    >
      <Box height={20} width={175}>
        <Link to={paths.root}>
          <Logo />
        </Link>
      </Box>
      <Box pr={2}>
        <LogoutButton />
      </Box>
    </HeaderFlex>
  )
}
